/** Same continuous two-slope scale as the PWA workout curve. */
export function powerFocusRatio(value: number, ceiling: number): number {
  if (ceiling <= 1000)
    return Math.max(0, Math.min(1, value / Math.max(1, ceiling)));
  const n = Math.max(0, Math.min(ceiling, value));
  return n <= 1000
    ? (n / 1000) * 0.75
    : 0.75 + ((n - 1000) / (ceiling - 1000)) * 0.25;
}

/** Tick density follows the rendered scale, including its compressed upper band. */
export function powerAxisTicks(
  ceiling: number,
  plotHeight: number,
  minGap = 24,
): number[] {
  if (!Number.isFinite(ceiling) || ceiling <= 0) return [0];
  const height = Math.max(1, plotHeight);
  const candidates: number[] = [];
  for (let value = 200; value <= Math.min(1000, ceiling); value += 200)
    candidates.push(value);
  if (ceiling > 1000) {
    const required = Math.max(
      500,
      (minGap / (height * 0.25)) * (ceiling - 1000),
    );
    const magnitude = 10 ** Math.floor(Math.log10(required));
    const step =
      [1, 2, 2.5, 5, 10].map(n => n * magnitude).find(n => n >= required) ??
      magnitude * 10;
    for (
      let value = Math.floor(1000 / step + 1) * step;
      value < ceiling;
      value += step
    )
      candidates.push(value);
  }
  const ticks = [0];
  for (const value of candidates) {
    const position = powerFocusRatio(value, ceiling) * height;
    const previous = powerFocusRatio(ticks[ticks.length - 1], ceiling) * height;
    // Reserve the top label so a final short interval never crowds it.
    if (
      value < ceiling &&
      position - previous >= minGap &&
      height - position >= minGap
    )
      ticks.push(value);
  }
  ticks.push(ceiling);
  return ticks;
}
